<template>
  <div v-if="!currentView">
    <h1>Konto-Typ wählen</h1>

    <p>Bitte wählen Sie Ihren Konto-Typ. Achtung: Sie können den Typ später nicht mehr verändern.</p>

    <el-button
      round
      @click="currentView = $config.groups.COACH"
    >
      Als <strong>Coach</strong> registrieren
    </el-button>

    <el-button
      round
      @click="currentView = $config.groups.COACHEE"
    >
      Als <strong>Coachee</strong> registrieren
    </el-button>
  </div>
  <component
    :is="currentView"
    v-else
  />
</template>

<script>
import config from '@/config'

export default {
  name: 'VSignupProfile',

  metaInfo: {
    title: 'Konto-Typ wählen'
  },

  components: {
    [config.groups.COACH]: () => import(/* webpackChunkName: "v-signup-coach" */ '@/views/VSignup/VSignupCoach'),
    [config.groups.COACHEE]: () => import(/* webpackChunkName: "v-signup-coachee" */ '@/views/VSignup/VSignupCoachee')
  },

  data () {
    return {
      currentView: null
    }
  }
}
</script>
